<template>
  <v-row dense justify="center">
    <v-col cols="12" class="title d-flex align-center">
      <v-icon color="secondary" left>mdi-clipboard-text</v-icon> Minhas Sessões Agendadas
    </v-col>
    <template v-if="eventSessions && eventSessions.length">
      <v-col cols="12" md="6" v-for="eventSession in eventSessions" :key="`event-session-${eventSession.id}`">
        <v-card outlined flat class="fill-height">
          <v-card-subtitle class="font-weight-black black--text">
            <v-icon color="secondary" left>mdi-clipboard-text</v-icon> {{ eventSession.event.name }} {{ eventSession.time_converted }}
          </v-card-subtitle>
          <v-card-text class="pb-0">
            <template v-if="eventSession.has_unlimited_places">
              Vagas Ilimitadas
            </template>
            <template v-else>
              Total de Vagas: {{ eventSession.places }}, Restantes: {{ eventSession.total_places_remaining }}
            </template>
          </v-card-text>
          <v-card-text>
            Anotações:
            <div class="notes" v-html="eventSession.notes"/>
          </v-card-text>
          <v-card-actions>
            <v-btn block depressed @click="unsubscribeEventSession(userState.person.student.id, eventSession.id)">
              Retirar Inscrição
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12">
        <v-alert type="info" border="left" colored-border>Não há sessões disponíveis</v-alert>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { Student } from '@/services/resources'
import { mapGetters } from 'vuex'

export default {
  name: 'Annotations',
  data () {
    return {
      eventSessions: null
    }
  },
  mounted () {
    this.loadEventSessions()
  },
  methods: {
    loadEventSessions () {
      Student.eventSessions()
        .then(response => {
          this.eventSessions = response.data.eventSessions
        }).catch((error) => {
          console.log('responseError', error)
          this.$toasted.global.error({ message: error.statusText })
        })
    },
    unsubscribeEventSession (studentId, eventSessionId) {
      if (window.confirm('Deseja realmente se desinscrever dessa sessão?')) {
        Student.unsubscribeEventSession(studentId, eventSessionId)
          .then(response => {
            this.$toasted.global.success({ message: 'Você se desinscreveu da sessão.' })
            this.loadEventSessions()
          }).catch((error) => {
            if (typeof error.body.message !== 'undefined') {
              this.$toasted.global.error({ message: error.body.message })
            } else {
              this.$toasted.global.error({ message: error.statusText })
            }
          })
      }
    }
  },
  computed: {
    ...mapGetters({
      userState: 'App/user'
    })
  }
}
</script>

<style>
.notes img {
  max-width: 100% !important;
}
</style>
